export const vcuSKUs = {
    plans: [
      {
        id: 'VCU-MONTH-TECHNET',
        name: 'Virtual Classroom Unlimited for TechNet members',
        price: 6900,
        description:
          'Access to all Virtual Classroom courses for all technicians working at your shop.',
        period_unit: 'month',
        product_type: 'vilt',
        status: 'active',
        visibility: 'public',
      },
      {
        id: 'VCU-MONTH',
        name: 'Virtual Classroom Unlimited',
        price: 9900,
        description:
          'Access to all Virtual Classroom courses for all technicians working at your shop.',
        period_unit: 'month',
        product_type: 'vilt',
        status: 'active',
        visibility: 'public',
      },
      // {
      //   id: 'CTIU-MONTH',
      //   name: 'CTI Unlimited',
      //   price: 12900,
      //   description:
      //     'Access to all CTI Training content (Online, Zoom, In-person). $129 for first user, plus $45 per additional user.',
      //   period_unit: 'month',
      //   product_type: 'vilt',
      //   status: 'active',
      //   visibility: 'public',
      // },
    ],
  }